import { faImages } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Flex, Typography } from "antd"
import { useContext } from "react"
import ImageUploader from "../../MyCompany/Components/ImageUploader"
import TenantsContext from "../../MyTenant/TenantsContext"

const { Title } = Typography

const TenantLogoAndImagesSection = () => {
  const { state: { images, serverImages }, dispatch } = useContext(TenantsContext)

  return <section>
    <Title level={5}><FontAwesomeIcon icon={faImages} /> Logo & Images</Title>
    <hr />
    <Flex gap={10} wrap="wrap">
      <ImageUploader
        src={images.logo || serverImages.logo}
        text="LOGO"
        onSetImage={(image) => dispatch({ type: "SET_IMAGES", payload: { ...images, logo: image } })}
      />
      <ImageUploader
        src={images.customer || serverImages.customer}
        text="CUSTOMERS"
        onSetImage={(image) => dispatch({ type: "SET_IMAGES", payload: { ...images, customer: image } })}
      />
      <ImageUploader
        src={images.property || serverImages.property}
        text="PROPERTIES"
        onSetImage={(image) => dispatch({ type: "SET_IMAGES", payload: { ...images, property: image } })}
      />
      <ImageUploader
        src={images.projects || serverImages.projects}
        text="PROJECTS"
        onSetImage={(image) => dispatch({ type: "SET_IMAGES", payload: { ...images, projects: image } })}
      />
      <ImageUploader
        src={images.item || serverImages.item}
        text="ITEMS"
        onSetImage={(image) => dispatch({ type: "SET_IMAGES", payload: { ...images, item: image } })}
      />
      <ImageUploader
        src={images.template || serverImages.template}
        text="TEMPLATES"
        onSetImage={(image) => dispatch({ type: "SET_IMAGES", payload: { ...images, template: image } })}
      />
      <ImageUploader
        src={images.setup || serverImages.setup}
        text="SETUP"
        onSetImage={(image) => dispatch({ type: "SET_IMAGES", payload: { ...images, setup: image } })}
      />
    </Flex>
  </section>
}

export default TenantLogoAndImagesSection